import "./base.js";
import.meta.glob("./summary/items/*.{js,hbs,jst.ejs}", { eager: true });

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

const __SummaryPrior = AppointmentBooking.Wizard.Views.Summary;
AppointmentBooking.Wizard.Views.Summary = class Summary extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.summaryItems = [];
    this.summaryItems.push(
      new AppointmentBooking.Wizard.Views.Summary.DoctorItem({
        model: this.model,
      }),
    );
    this.summaryItems.push(
      new AppointmentBooking.Wizard.Views.Summary.AddressItem({
        model: this.model,
      }),
    );
    return this.summaryItems.push(
      new AppointmentBooking.Wizard.Views.Summary.AppointmentSlotItem({
        model: this.model,
      }),
    );
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.replaceContents(
      ".summary-items-container",
      this.summaryItems.map((summaryItem) => summaryItem.render().el),
    );

    return this;
  }
};
AppointmentBooking.Wizard.Views.Summary.prototype.template = "summary";
AppointmentBooking.Wizard.Views.Summary.prototype.className = "appointment-booking-wizard-summary";
if (__SummaryPrior) {
  Object.assign(AppointmentBooking.Wizard.Views.Summary, __SummaryPrior);
}
